import i18n from '@/locales';
import { calcYoY, transformColor } from '@/utils/api';

export function useFinanceChartOption() {
	const mainIndex = (subId, data, origin) => {
		const option = {
			seriesData: [
				{
					name: origin.name,
					type: 'bar',
					data: data.map(ele => ({ name: ele.year, value: ele[origin.key], unit: origin.unit }))
				},
				origin.yoyKey
					? {
							name: i18n.t('enterprise.YoY'),
							type: 'line',
							yAxisIndex: 1,
							data: data.map(ele => ({
								name: ele.year,
								value: calcYoY(ele[origin.key], ele[origin.yoyKey]),
								unit: '%'
							}))
					  }
					: null
			]
		};
		return option;
	};

	const balanceSheet = (subId, data, origin) => {
		let option;
		if (['asset', 'liabilities'].includes(subId)) {
			const list = origin[subId];
			option = {
				seriesData: list.map(item => {
					return {
						name: item.name,
						type: 'bar',
						stack: 'a',
						data: data.map(ele => [ele.year, ele[item.key]]),
						itemStyle: {
							color: item.color,
							emphasis: {
								color: transformColor(item.color)
							}
						}
					};
				}),
				chartOptions: {
					legend: {
						data: list.map(series => series.name).reverse()
					}
				},
				isReverse: true
			};
		} else {
			const list = origin['others'];
			option = {
				seriesData: list.map(item => ({
					name: item.name,
					type: 'bar',
					data: data.map(ele => [ele.year, ele[item.key]])
				}))
			};
		}

		return option;
	};

	const profitStatement = (subId, data, origin) => {
		const option = {
			seriesData: [
				{
					name: origin.name,
					type: 'bar',
					data: data.map(ele => ({ name: ele.year, value: ele[origin.key] }))
				},
				{
					name: i18n.t('enterprise.YoY'),
					type: 'line',
					yAxisIndex: 1,
					data: data.map(ele => ({
						name: ele.year,
						value: calcYoY(ele[origin.key], ele[origin.yoyKey]),
						unit: '%'
					}))
				}
			]
		};
		return option;
	};

	const cashFlowStatement = (subId, data, origin) => {
		const list = origin['default'];
		const option = {
			seriesData: list.map(item => ({
				name: item.name,
				type: 'bar',
				data: data.map(ele => [ele.year, ele[item.key]])
			}))
		};
		return option;
	};

	const registry = {
		main_index: mainIndex,
		profit_statement: profitStatement,
		balance_sheet: balanceSheet,
		cash_flow_statement: cashFlowStatement
	};
	const getChartOption = (moduleId, subId, data, origin) => {
		const chartOption = registry[moduleId]?.(subId, data, origin) || {};
		if (chartOption.seriesData) {
			chartOption.seriesData = chartOption.seriesData.filter(ele => !!ele);
		}
		return chartOption;
	};

	return {
		getChartOption
	};
}
